import { Directive, inject, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Test/Mock directive for the real appUserHasPermissions directive for using it in other test suites.
 */
@Directive({
  selector: '[appUserHasPermissions]',
  standalone: true,
})
export class UserHasPermissionsMockDirective implements OnInit, OnDestroy {
  templateRef = inject(TemplateRef<unknown>);

  viewContainerRef = inject(ViewContainerRef);

  /**
   * call next(false) if you want to test the unauthorized case.
   */
  isAuthorized$ = new BehaviorSubject<boolean>(true);

  ngOnInit() {
    this.isAuthorized$.subscribe(authorized => {
      if (authorized) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
        return;
      }
      this.viewContainerRef.clear();
    });
  }

  ngOnDestroy() {
    this.isAuthorized$.complete();
  }
}
